import React, { useRef } from "react";
// Import Swiper React components
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import user from "../../assets/pic/avatar.png";
import down from "../../assets/pic/down.svg";
import leftCaraousal from "../../assets/pic/leftcaraousal.svg";
import profileImage from "../../assets/pic/olduser.webp";
import rightCaraousal from "../../assets/pic/rightCaraousal.svg";
import up from "../../assets/pic/up.svg";
import { LayoutForLandingPage } from "./Home";
const Reviews = () => {
  const swiperRef = useRef(null);
  const reviews = [
    {
      text: "To Bre has been a joy to use. I’ve been scheduling cards for birthdays and milestones for all of my grandkids. My daughter told me the kids now love checking the mailbox for my cards! They love it!",
      username: "Barbara, 68",
      // position: "Project Manager",
      path: profileImage,
    },
    {
      text: "My grandparents don’t do texting, so occasionally sending them real cards means everything. They feel so loved, and I don’t have to stress about missing a special day.",
      username: "Amy, 47",
      // position: "Software Engineer",
      path: user,
    },
    {
      text: "I live across the country from my folks and To Bre makes it very easy to send them something personal and special. My Grandad keeps every card on his fridge!",
      username: "Tolu, 39",
      path: user,
      // position: "Creative Director",
    },
    {
      text: "As busy Mom part of a large family, I don’t always have time to run to the store for cards. To Bre has been a total game-changer for me! The messages also feel so personal and it's never been easier to stay connected with my relatives.",
      username: "Melissa, 55",
      path: user,
      // position: "CEO, Startup Inc.",
    },
  ];
  return (
    <div className="bg-[#2F3649] py-8 relative ">
      <LayoutForLandingPage>
        <h2 className="text-white md:text-5xl text-2xl font-bold mb-6 text-center">
          What our <span className="text-[#F66]">user's say </span>
        </h2>
        {/* Swiper Carousel */}
        <Swiper
          ref={swiperRef}
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          slidesPerView={1} // Initially, show one card
          spaceBetween={40} // Spacing between cards
          breakpoints={{
            640: { slidesPerView: 1 }, // Show 1 card on small screens
            768: { slidesPerView: 2 }, // Show 2 cards on medium screens
            1024: { slidesPerView: 3 }, // Show 3 cards on large screens
          }}
          navigation={false}
          style={{
            paddingBottom: "40px",
            paddingLeft: "10px",
            paddingRight: "10px",
          }} // Add left and right padding
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div
                className={`${
                  index === 0
                    ? "bg-[#E3F1E9]"
                    : index === 1
                    ? "bg-[#EFEAE5]"
                    : "bg-[#F2E6E7]"
                } text-black p-6 rounded-lg shadow-lg relative flex flex-col gap-4 h-96`}
              >
                <img src={up} width={40} className="items-start" alt="" />
                {/* Review Text */}
                <p className="text-left text-lg mb-2">{review.text}</p>
                {/* Icon and User Info */}
                <div className="flex justify-end">
                  <img
                    src={down}
                    width={40}
                    className="items-end flex justify-end"
                    alt=""
                  />
                </div>
                <div className="flex gap-2 items-center absolute bottom-6">
                  <img
                    src={review?.path}
                    alt=""
                    className="w-12 h-12 rounded-full"
                  />
                  {/* Username and Position */}
                  <div className="">
                    <h4 className="font-semibold text-lg">{review.username}</h4>
                    {/* <p className="text-sm text-gray-400">{review.position}</p> */}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Swiper Arrows */}
        <div className="flex justify-center gap-2 mt-4">
          <img
            className="react-swiper-prev cursor-pointer"
            onClick={() => swiperRef.current.swiper.slidePrev()} // Go to previous slide
            src={leftCaraousal}
            alt=""
          />
          <img
            className="react-swiper-next cursor-pointer"
            onClick={() => swiperRef.current.swiper.slideNext()}
            src={rightCaraousal}
            alt=""
          />
        </div>
      </LayoutForLandingPage>
    </div>
  );
};

export default Reviews;
